import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../api/index.js';
import { setUser } from '../utils/storageHelper.js';
import fetchHelper from '../utils/fetchHelper.js';

export const sendResetPasswordEmail = createAsyncThunk(
    'auth/sendResetPasswordEmail',
    async ({ email }, { rejectWithValue }) => {
        try {
            await API.resetPassword.sendEmail({ email });
            return true;
        } catch (err) {
            return rejectWithValue(err.message || 'Error sending reset password email');
        }
    },
);

export const resetPassword = createAsyncThunk(
    'auth/resetPassword',
    async ({ password, token }, { rejectWithValue }) => {
        try {
            const user = await API.resetPassword.reset({ password }, token);
            return user;
        } catch (err) {
            return rejectWithValue(err.message || 'Error resetting password');
        }
    },
);

export const handleInvalidToken = createAsyncThunk('auth/handleInvalidToken', async ({ user }, { rejectWithValue }) => {
    try {
        fetchHelper.setToken(user.token);
        setUser(user);
        return true;
    } catch (err) {
        return rejectWithValue(err.message || 'Failed to handle invalid token');
    }
});
